/**
 * Author:Murugaeswari
 * Modified by:kani,Murugaeswari
 * Modified Date: 2025-05-05
 */
// PricingPlans.js
import React, { useRef, useEffect, useState } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody
} from "reactstrap";

import { getLoggedInUser, checkLoginToken } from "../../helpers/fakebackend_helper"
import * as url from "../../helpers/url_helper";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import './PricingPlans.css';
import classnames from 'classnames';
import Checkout from './checkout';
export default function MySubscription() {
  const checkoutRef = useRef();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [activePlans, setActivePlans] = useState([]);
  const [expiredPlans, setExpiredPlans] = useState([]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleSubscribeClick = (plan) => {

    if (checkoutRef.current) {
      checkoutRef.current.checkProfileCompetion(plan);
    }
  };
  useEffect(() => {
    getSubscribedList()
  }, [])
  const getSubscribedList = async () => {
  

    // checkLoginToken(navigate)
    const user = getLoggedInUser()
    const data = {
      stid: Number(user.UserInfo.stid),
    }
    setLoading(true);
    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
    try {
      const response = await axios.post(url.BASE_URL + 'subscription/getSubscribedList', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }
      setLoading(false);

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();
        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await getSubscribedList();
          }
        }
      }


      if (response?.data?.body?.list) {
        var activeList = response?.data?.body?.list.filter(item => item?.status_id === 1);
        setActivePlans(activeList)
        var expiredList = response?.data?.body?.list.filter(item => item?.status_id === 8);
        setExpiredPlans(expiredList)
      } else {
        setLoading(false);
        // toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      setLoading(false);
      // Handle error
      console.error("student detailsAPI Error:", error);
    }
  }
  return (
    <div>
 <Checkout ref={checkoutRef} />
      <div className="pricing-wrapper card" style={{ padding: '16px', background: '#fff !important' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '16px' }}>
  <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
    My Subscriptions
  </div>

</div>

        <Nav tabs className="nav-tabs-custom">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' })}
              onClick={() =>
                { 
                  toggle('1')
                  getSubscribedList()
                }}
            >
              Active
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '2' })}
              onClick={() =>
                { 
                  toggle('2')
                  getSubscribedList()
                }}
            >
              Expired
            </NavLink>
          </NavItem>

        </Nav>

        <TabContent activeTab={activeTab} className="p-3">
          <TabPane tabId="1">

            <div className="row" style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
            {activePlans && activePlans.length == 0 &&
                <div className="col-12 col-md-6 col-lg-3 mb-4 d-flex">
                  
                      <div style={{ fontSize: '14px', fontStyle: 'italic' }}>No plans found.</div>
                   
                  </div>

              }
              {activePlans.map((item) => (
                <div key={item.subscription_id} className="col-12 col-md-6 col-lg-3 mb-4 d-flex">
                  <Card className="w-100 ">
                    <CardBody className="subscription-card">
                      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{item.plan_name}</div>
                      <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-12">
                          <div className="font-size-13" title={item?.category_plan} style={{maxWidth:'290px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingBottom: 4 ,paddingTop:4,color:'darkgoldenrod',fontWeight:'500'}}>
                            {item?.category_plan}
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-5">
                          <p style={{ color: 'green' }}>
                            <i className="mdi mdi-currency-inr" />
                            {item.amount} | {item.validity}
                          </p>
                        </div>
     
                      </div>

                      <p style={{ borderTop: '1px solid #000', paddingTop: '16px' }}>
                        <i className="mdi mdi-check-circle-outline me-2" />
                        No. of Tests Attempted: <strong>{item.test_attempted}</strong> / {item.no_of_test}
                      </p>

                      <p>
                        <i className="mdi mdi-grid me-2" />
                        Questions per Test: {item.total_questions}
                      </p>

                      <p>
                        <i className="mdi mdi-calendar me-2" />
                        Subscribed on:{item.start_at}
                      </p>

                      <p style={{ color: 'red' }}>
                        <i className="mdi mdi-alarm me-2" />
                        {item.expire_text}: {item.expired_at}
                      </p>

                      <button className="btn btn-primary" onClick={() =>   navigate("/testseries",{state:{subscription_id:item.subscription_id, plan_id:item.plan_id, category_id:item.category_id, sub_conf_id:item.sub_conf_id, plan_name:item.plan_name, category_plan:item.category_plan, amount:item.amount, validity:item.validity}})}>SELECT</button>
                    </CardBody>
                  </Card>  </div>
              ))}
            </div>



          </TabPane>

          <TabPane tabId="2">
            <div className="row">
              {expiredPlans && expiredPlans.length == 0 &&
                <div className="col-12 col-md-6 col-lg-3 mb-4 d-flex">
                  
                      <div style={{ fontSize: '14px', fontStyle: 'italic' }}>No plans found.</div>
                   
                  </div>

              }
              {expiredPlans.map((item) => (
                <div key={item.subscription_id} className="col-12 col-md-6 col-lg-3 mb-4 d-flex">
                  <Card className="w-100 ">
                    <CardBody className="subscription-card">
                      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{item.plan_name}</div>

                      <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-12">
                          <div className="font-size-13" title={item?.category_plan} style={{maxWidth:'290px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingBottom: 4 ,paddingTop:4,color:'darkgoldenrod',fontWeight:'500'}}>
                            {item?.category_plan}
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-5">
                          <p style={{ color: 'green' }}>
                            <i className="mdi mdi-currency-inr" />
                            {item.amount} | {item.validity}
                          </p>
                        </div>
     
                      </div>

                      <p style={{ borderTop: '1px solid #000', paddingTop: '16px' }}>
                        <i className="mdi mdi-check-circle-outline me-2" />
                        No. of Tests Attempted: <strong>{item.test_attempted}</strong> / {item.no_of_test}
                      </p>

                      <p>
                        <i className="mdi mdi-grid me-2" />
                        Questions per Test: {item.total_questions}
                      </p>

                      <p>
                        <i className="mdi mdi-calendar me-2" />
                        Subscribed on:{item.start_at}
                      </p>

                      <p style={{ color: 'red' }}>
                        <i className="mdi mdi-alarm me-2" />
                         {item.expire_text}: {item.expired_at}
                      </p>

                      {item?.renewal_flag == 1 ? <button onClick={() => handleSubscribeClick(item)} className="btn btn-warning">RENEW</button> : <button className="btn btn-danger">UNAVAILABLE</button>}
                    </CardBody>
                  </Card>  </div>
              ))}
            </div>

          </TabPane>


        </TabContent>

      </div>
    </div>


  );
}
